import React, { useRef } from "react";
import Parse from "parse";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import Navbar from "./NavBar/NavBar";
import moment from "moment-with-locales-es6";
import { saveAs } from "file-saver";
import "../StylesPages/profile.css";
import YouTube from "react-youtube";
import { Flex, Image, Box, Text, calc, Center } from "@chakra-ui/react";
import { Button } from "@chakra-ui/react";
import AfficherOffres from "./AfficherOffres";
import { Grid } from "@mantine/core";
import Pdf from "@mikecousins/react-pdf";

function DetailUser() {
  async function fetchUser() {
    const User = Parse.Object.extend("_User");
    const query = new Parse.Query(User);
    query.equalTo("objectId", id.split("&")[0]);
    const user = await query.first();
    setUser(user);
    if (user.get("cv") !== undefined) {
      setPdfUrl(user.get("cv").url());

      console.log(user.get("cv").url());
    }
    return user;
  }

  async function fetchVideo() {
    const user = await fetchUser();
    const Video = Parse.Object.extend("Video");
    const query = new Parse.Query(Video);
    console.log(user.get("tags"));
    query.equalTo("userId", user);
    const video = await query.first();
    const ytId = youtube_parser(video.get("videoUrl"));
    console.log("aaaaaaaa");
    console.log(ytId);
    setVideo(ytId);

    return video;
  }
  async function fetchOffer() {
    if (id.split("&")[1] !== undefined) {
      const Annonce = Parse.Object.extend("Annonce");
      const query = new Parse.Query(Annonce);
      query.equalTo("objectId", id.split("&")[1]);
      const offer = await query.first();
      setOffre(offer);
      if (offer !== undefined) {
        const listUser = offer.get("listUser");
        const exist = listUser.includes(id.split("&")[0]);
        console.log(exist);
        setShowButtons(exist);
      }
      return offer;
    }
  }

  const onClick = () => {
    if (user.get("cv") !== undefined) {
      saveAs(
        user.get("cv").url(),
        `${user.get("nom")}_${user.get("prenom")}_CV.pdf`
      );
    } else {
      alert("cet utilisateur n'a pas de CV");
    }
  };

  const removeUserFromUserList = () => {
    const usersApplyed = offre.get("listUser");
    if (usersApplyed !== undefined) {
      const filtered = usersApplyed.filter(function (value, index, arr) {
        return value !== id.split("&")[0];
      });
      offre.set("listUser", filtered);
    }
  };

  const createNotification = (message, code) => {
    let notification = Parse.Object.extend("Notification");
    let entity = new notification();

    entity.set("userId", Parse.User.current());
    entity.set("idRecruteur", Parse.User.current());
    entity.set("idCandidat", user);
    entity.set("notifSender", code);
    entity.set("message", message);
    entity.set("lu", false);
    entity.set("etat", "attente");
    entity.set("reponse", false);
    entity.set("type", "job");
    entity.set("idAnnonce", offre);
    entity.save();
  };

  const createChatroom = async () => {
    let Thread = Parse.Object.extend("Thread");

    const currentUser = Parse.User.current();
    console.log("sazzzzzzzzsa");
    console.log(currentUser);
    const query1 = new Parse.Query(Thread);
    query1.equalTo("userId1", currentUser);
    query1.equalTo("userId2", user);

    const query2 = new Parse.Query(Thread);
    query2.equalTo("userId2", currentUser);
    query2.equalTo("userId2", user);

    const mainQuery = Parse.Query.or(query1, query2);

    const res = await mainQuery.first();

    if (res === undefined) {
      let thread = new Thread();
      thread.set("userId1", currentUser);
      thread.set("userId2", user);
      thread.set(
        "pseudo1",
        currentUser.get("prenom") + " " + currentUser.get("nom")
      );
      thread.set("pseudo2", user.get("prenom") + " " + user.get("nom"));
      thread.save();
    }
  };

  const refuseUser = () => {
    removeUserFromUserList();
    let usersRefused = offre.get("applyRefused");
    if (usersRefused === undefined) {
      usersRefused = [];
    }
    usersRefused.push(id.split("&")[0]);
    offre.set("applyRefused", usersRefused);
    createNotification(
      "Nous sommes dans le regret de vous informez que votre candidature a été refusé pour l'offre " +
        offre.get("titre") +
        " par le recruteur " +
        user.get("nom") +
        " " +
        user.get("prenom"),
      0
    );
    offre.save();
    setShowButtons(false);
  };

  const acceptUser = () => {
    removeUserFromUserList();
    let usersAccepted = offre.get("applyAccepted");
    if (usersAccepted === undefined) {
      usersAccepted = [];
    }
    usersAccepted.push(id.split("&")[0]);
    offre.set("applyAccepted", usersAccepted);

    createNotification(
      "Votre candidature a été accepté pour l'offre " +
        offre.get("titre") +
        " par le recruteur " +
        user.get("nom") +
        " " +
        user.get("prenom"),
      0
    );
    offre.save();
    createChatroom();
    setShowButtons(false);
  };

  const [user, setUser] = useState();
  const [video, setVideo] = useState();
  const [offre, setOffre] = useState();
  const [showButtons, setShowButtons] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    fetchVideo();
    fetchOffer();
  }, []);

  useEffect(() => {
    if (!user) return;
  }, [user]);

  const opts = {
    height: "95%",
    width: "95%",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      // autoplay: 1,
    },
  };

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  function youtube_parser(url) {
    var regExp =
      /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return match && match[7].length == 11 ? match[7] : false;
  }
  const { id, ofr } = useParams();
  const [page, setPage] = useState(1);
  const [pdfUrl, setPdfUrl] = useState();

  return (
    <Box display="flex" w={"100%"}>
      <Navbar />
      <Box
        mt={["20px", "20px", "0px", "0px"]}
        w={"100%"}
        mb={["120px", "120px", "0px", "0px"]}
      >
        <Text
          ml={["20px", "20px", "40px", "40px"]}
          fontFamily={"Sofia pro"}
          fontSize={"36px"}
          fontWeight={"bolder"}
        >
          Details de {user ? `${user.get("prenom")}  ${user.get("nom")}` : ""}
        </Text>
        <Box
          p="0px"
          mx={["10px", "10px", "50px", "50px"]}
          mt={["20px", "20px", "36px", "36px"]}
          w={["100%", "100%", "calc(100% - 100px) ", "calc(100% - 100px)"]}
          h={["100%", "100%", "calc(100% - 100px) ", "calc(100% - 100px)"]}
          bg="white"
          borderRadius={"25px"}
        >
          <Flex>
            <Grid gutter="lg" w={"100%"} h={"100%"}>
              <Grid.Col key="1" xs={12} sm={12} md={5} lg={5} xl={5}>
                <Box
                  bg="#d4eeff"
                  p={4}
                  borderRadius={"20px"}
                  w={"100%"}
                  h={["55%", "55%", "65%", "65%"]}
                >
                  {user ? (
                    <Box>
                      <Box display={"flex"} p={"20px 20px 0px 20px"}>
                        <Grid gutter="lg" w={"100%"}>
                          <Grid.Col key={"im"} span={4}>
                            <Image
                              src={
                                user.get("avatar")
                                  ? user.get("avatar").url()
                                  : ""
                              }
                              alt={user.get("nom") ? user.get("nom") : "user"}
                              borderRadius="full"
                              boxSize={["80px", "80px", "125px", "125px"]}
                              border={"8px"}
                              borderWidth={"10px"}
                              borderColor={"#ffffff"}
                              marginBottom={"20px"}
                            />
                          </Grid.Col>
                          <Grid.Col key={"in"} span={8}>
                            <Box h={"100%"}>
                              <Text
                                fontFamily={"Sofia pro"}
                                fontSize={"24px"}
                                fontWeight={"bolder"}
                              >
                                {user.get("situation")}
                              </Text>
                              <Text
                                fontFamily={"Sofia pro"}
                                fontSize={"14px"}
                                fontWeight={"normal"}
                              >
                                {user.get("current_job")}
                              </Text>
                              <Flex>
                                <Text
                                  fontFamily={"Sofia pro"}
                                  fontSize={"14px"}
                                  fontWeight={"normal"}
                                  mr={"3px"}
                                >
                                  Recherche
                                </Text>
                                <Text
                                  fontFamily={"Sofia pro"}
                                  fontSize={"14px"}
                                  fontWeight={"normal"}
                                  textColor={"#F1404B"}
                                  mr={"3px"}
                                >
                                  {user.get("contrat")}
                                </Text>
                                <Text
                                  fontFamily={"Sofia pro"}
                                  fontSize={"14px"}
                                  fontWeight={"normal"}
                                  mr={"3px"}
                                >
                                  en
                                </Text>
                                <Text
                                  display={["none", "none", "block", "block"]}
                                  fontFamily={"Sofia pro"}
                                  fontSize={"14px"}
                                  fontWeight={"normal"}
                                  textColor={"#F1404B"}
                                >
                                  {user.get("secteur")}
                                </Text>
                              </Flex>
                              <Text
                                display={["block", "block", "none", "none"]}
                                fontFamily={"Sofia pro"}
                                fontSize={"14px"}
                                fontWeight={"normal"}
                                textColor={"#F1404B"}
                              >
                                {user.get("secteur")}
                              </Text>
                              <Flex alignItems={"center"}>
                                <Text
                                  fontFamily={"Sofia pro"}
                                  fontSize={"25px"}
                                  fontWeight={"bold"}
                                  mr={"10px"}
                                >
                                  @
                                </Text>
                                <Text
                                  fontFamily={"Sofia pro"}
                                  fontSize={"14px"}
                                  fontWeight={"bold"}
                                  mr={"3px"}
                                >
                                  {user.get("username")}
                                </Text>
                              </Flex>
                            </Box>
                          </Grid.Col>
                          {/* <Button onClick={onClick}>Download CV</Button> */}
                        </Grid>
                      </Box>
                      <Box p={"0px 20px 20px 20px"}>
                        <Text
                          fontFamily={"Sofia pro"}
                          fontSize={"24px"}
                          fontWeight={"bolder"}
                        >
                          A propos
                        </Text>
                        <Flex
                          alignItems={"center"}
                          justifyContent={"center"}
                          bg={"white"}
                          borderRadius={"20px"}
                          p={"30px"}
                          mt={"25px"}
                        >
                          <Text
                            fontFamily={"Sofia pro"}
                            fontSize={"14px"}
                            fontWeight={"normal"}
                          >
                            {user.get("description")}
                          </Text>
                        </Flex>
                      </Box>
                    </Box>
                  ) : (
                    ""
                  )}
                </Box>
                <Box
                  m={["0px", "0px", "40px 0px 0px 0px", "40px 0px 0px 0px"]}
                  p={4}
                  borderRadius={"20px"}
                  w={"100%"}
                  h={"30%"}
                >
                  {offre !== undefined && showButtons ? (
                    <Box>
                      <Text
                        fontFamily={"Sofia Pro"}
                        fontSize={"24px"}
                        fontWeight={"bolder"}
                      >
                        Accepter ou refuser la candidature ({offre.get("titre")}
                        )
                      </Text>
                      <Text
                        fontFamily={"Sofia Pro"}
                        fontSize={"14px"}
                        fontWeight={"normal"}
                        mt={"35px"}
                      >
                        Si vous acceptez, vous passez la première étape du
                        processus de recrutement.
                      </Text>
                      <Text
                        fontFamily={"Sofia Pro"}
                        fontSize={"14px"}
                        fontWeight={"normal"}
                      >
                        Si vous refusez, vous ne verrez plus ce profil. Le
                        candidat est averti de chaque choix.
                      </Text>

                      <Box marginTop={"35px"} textAlign={"center"}>
                        <Button
                          bg="#6FCF97"
                          onClick={acceptUser}
                          mr={"30px"}
                          fontFamily={"Sofia Pro"}
                          fontSize={"14px"}
                          fontWeight={"bolder"}
                          textColor={"white"}
                          borderRadius={"20px"}
                          w={"40%"}
                        >
                          Accepter
                        </Button>
                        <Button
                          bg="#EB5757"
                          onClick={refuseUser}
                          mr={"30px"}
                          fontFamily={"Sofia Pro"}
                          fontSize={"14px"}
                          fontWeight={"bolder"}
                          textColor={"white"}
                          borderRadius={"20px"}
                          w={"40%"}
                        >
                          Refuser
                        </Button>
                      </Box>
                    </Box>
                  ) : (
                    ""
                  )}
                </Box>
              </Grid.Col>
              <Grid.Col key="2" xs={12} sm={12} md={3} lg={3} xl={3}>
                <Box
                  bg="#d4eeff"
                  p={4}
                  borderRadius={"20px"}
                  w={"100%"}
                  h={["45%", "65%"]}
                >
                  <Text
                    fontFamily={"Sofia pro"}
                    fontSize={"24px"}
                    fontWeight={"bolder"}
                    mb={"10px"}
                  >
                    Vidéo
                  </Text>
                  {video ? (
                    <Box py="20%" display={"grid"} placeItems={"center"}>
                      <YouTube videoId={video} opts={opts} />
                    </Box>
                  ) : (
                    "pas de videos"
                  )}
                </Box>
                <Box
                  bg="#d4eeff"
                  p={4}
                  borderRadius={"20px"}
                  w={"100%"}
                  mt={"50px"}
                  h={["50%", "50%", "180px%", "180px"]}
                >
                  <Text
                    fontFamily={"Sofia pro"}
                    fontSize={"24px"}
                    fontWeight={"bolder"}
                    mb={"10px"}
                  >
                    Domaines
                  </Text>
                  <Grid>
                    {user
                      ? user
                          .get("tags")
                          .slice(0, 6)
                          .map((e, i) => (
                            <Grid.Col
                              key={i}
                              xs={4}
                              sm={4}
                              md={4}
                              lg={4}
                              xl={4}
                            >
                              <Text
                                bg="#F1404B"
                                p={"6px 10px"}
                                borderRadius={"20px"}
                                textColor={"white"}
                                textAlign={"center"}
                              >
                                #{e}
                              </Text>
                            </Grid.Col>
                          ))
                      : ""}
                  </Grid>
                </Box>
              </Grid.Col>
              <Grid.Col key="3" xs={12} sm={12} md={4} lg={4} xl={4}>
                <Box
                  display={["none", "none", "block", "block"]}
                  px={6}
                  borderRadius={"20px"}
                  w={"100%"}
                  h={"100%"}
                  sx={{
                    "> *": {
                      width: "100px",
                      height: "100px",
                      borderRadius: "20px",
                      boxShadow: "0px 0px 20px #C7C7CB66",
                    },
                  }}
                >
                  {pdfUrl ? (
                    <Pdf file={pdfUrl} page={page} scale={0.77}></Pdf>
                  ) : (
                    <Box
                      display={"grid"}
                      placeItems={"center"}
                      w={"458px"}
                      h={"640px"}
                    >
                      <Text
                        w={"60%"}
                        textAlign={"center"}
                        fontFamily={"Sofia pro"}
                        fontSize={"24px"}
                        textColor={"#C7C7CB"}
                        fontWeight={"bolder"}
                      >
                        Pas de CV disponible pour ce candidat
                      </Text>
                    </Box>
                  )}
                </Box>
              </Grid.Col>
            </Grid>
          </Flex>
        </Box>

        <Box>
          {/* <Flex p={8} w={"100%"} h={"100%"}>
            
          </Flex> */}
        </Box>
      </Box>
    </Box>
  );
}

export default DetailUser;
